/* Vittalogy Article System v4 - hydrates product cards, generates TOC and FAQ from semantic markup */
(function () {
  'use strict';

  var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var locale = (window.Shopify && window.Shopify.locale) || 'es';
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  var I18N = {
    es: { btn: 'IR AL PRODUCTO', toc: 'En este artículo', loading: 'Cargando producto...', soon: 'Producto próximamente.' },
    en: { btn: 'GO TO PRODUCT', toc: 'In this article', loading: 'Loading product...', soon: 'Product coming soon.' },
    fr: { btn: 'VOIR LE PRODUIT', toc: 'Dans cet article', loading: 'Chargement du produit...', soon: 'Produit bientôt disponible.' },
    it: { btn: 'VAI AL PRODOTTO', toc: 'In questo articolo', loading: 'Caricamento prodotto...', soon: 'Prodotto in arrivo.' },
    de: { btn: 'ZUM PRODUKT', toc: 'In diesem Artikel', loading: 'Produkt wird geladen...', soon: 'Produkt demnächst verfügbar.' },
    pt: { btn: 'VER PRODUTO', toc: 'Neste artigo', loading: 'A carregar produto...', soon: 'Produto em breve.' }
  };
  var L = I18N[locale] || I18N.es;

  function formatPrice(cents, curr) {
    var value = (cents / 100);
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: curr || currency }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' €';
    }
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function slugify(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .substring(0, 60);
  }

  /* Product cards are now server-side rendered via Liquid (main-article.liquid + article-product-card snippet) */
  function hydrateProductCards() { /* no-op kept for backwards compat */ }

  /* Sidebar de productos recomendados (v5): boton ATC -> /cart/add.js */
  function setupSidebarATC() {
    document.querySelectorAll('[data-vlg-atc]').forEach(function (btn) {
      if (btn.dataset.vlgBound === '1') return;
      btn.dataset.vlgBound = '1';
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.classList.contains('added')) return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        btn.disabled = true;
        fetch(R + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.classList.add('added');
            btn.setAttribute('aria-label', 'Añadido');
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () { btn.disabled = false; }, 1500);
          })
          .catch(function (err) {
            console.warn('[Vittalogy sidebar ATC] error:', err);
            btn.disabled = false;
          });
      });
    });
  }

  function buildToc() {
    var marker = document.querySelector('[data-vlg-toc]');
    if (!marker) return;
    var root = document.querySelector('.vlg-article') || document;
    var headings = root.querySelectorAll('h2');
    if (headings.length < 3) {
      marker.style.display = 'none';
      return;
    }
    var html = '<div class="vlg-toc__title">📖 ' + escapeHtml(L.toc) + '</div><ol>';
    headings.forEach(function (h, i) {
      var id = h.id || slugify(h.textContent) || ('sec-' + (i + 1));
      h.id = id;
      html += '<li><a href="#' + id + '">' + escapeHtml(h.textContent.trim()) + '</a></li>';
    });
    html += '</ol>';
    // Replace div marker with semantic <nav>
    var nav = document.createElement('nav');
    nav.className = 'vlg-toc';
    nav.setAttribute('aria-label', L.toc);
    nav.innerHTML = html;
    marker.parentNode.replaceChild(nav, marker);
  }

  function buildFaqAccordions() {
    var faqs = document.querySelectorAll('.vlg-faq');
    faqs.forEach(function (faq) {
      if (faq.querySelector('details')) return;
      var items = [];
      var current = null;
      Array.from(faq.children).forEach(function (node) {
        if (node.tagName === 'H3') {
          if (current) items.push(current);
          current = { q: node.innerHTML, body: [] };
        } else if (current) {
          current.body.push(node.outerHTML);
        }
      });
      if (current) items.push(current);
      if (!items.length) return;

      faq.innerHTML = items.map(function (item) {
        return '<details><summary>' + item.q + '</summary>' + item.body.join('') + '</details>';
      }).join('');
    });
  }

  function buildFaqSchema() {
    var faq = document.querySelector('.vlg-faq');
    if (!faq) return;
    if (document.querySelector('script[data-vlg-faq-schema]')) return;
    var items = [];
    faq.querySelectorAll('details').forEach(function (d) {
      var q = d.querySelector('summary');
      if (!q) return;
      var bodyEl = d.cloneNode(true);
      var sm = bodyEl.querySelector('summary');
      if (sm) sm.remove();
      var answer = bodyEl.textContent.trim().replace(/\s+/g, ' ');
      if (!answer) return;
      items.push({
        '@type': 'Question',
        name: q.textContent.trim(),
        acceptedAnswer: { '@type': 'Answer', text: answer }
      });
    });
    if (!items.length) return;
    var schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: items
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.setAttribute('data-vlg-faq-schema', '1');
    s.textContent = JSON.stringify(schema);
    document.head.appendChild(s);
  }

  function init() {
    buildToc();
    buildFaqAccordions();
    buildFaqSchema();
    hydrateProductCards();
    setupSidebarATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
